import React from 'react';
import {
    Box,
    IconButton,
    Tooltip,
    Typography,
    useTheme,
} from '@material-ui/core';
import { X } from 'react-feather';

export const Header = ({ onClose }: { onClose: () => void }) => {
    const theme = useTheme();

    return (
        <Box
            p={2}
            borderBottom={`1px solid ${theme.palette.divider}`}
            bgcolor={theme.palette.background.paper}
            display="flex"
            alignItems="center"
        >
            <Tooltip title="Cerrar">
                <IconButton color="primary" onClick={onClose}>
                    <X />
                </IconButton>
            </Tooltip>

            <Typography variant="h5" color="textPrimary">
                Llamadas recientes
            </Typography>
        </Box>
    );
};
